import { JSX } from 'react';

import { Routes } from 'react-router';

import { SentryRoute as Route } from '@vk-hr-tek/core/monitoring';

import { PageError } from '../../../layout';
import { PageRedirect } from '../../segments';
import { AuthById } from '../AuthById';

import { Login } from './Login';
import { VerifyAuthCode } from './VerifyAuthCode';
import { Register } from './Register';

export const VKAuth = (): JSX.Element => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path="result" element={<VerifyAuthCode />} />
      <Route path="invite" element={<PageRedirect to="login" />} />
      <Route path=":id">
        <Route path="*" element={<AuthById />} />
      </Route>
      <Route path="*" element={<PageError status={404} />} />
    </Routes>
  );
};
